export default __webpack_public_path__ + "static/plesyPoster-4699c9b161928e99eb2898a1fcc6d8ae.webp";